<div class="aero-dialog-footer-buttons"
     [ngClass]="{'aero-dialog-single-button' : !config.showSecondary}">
  <aero-button *ngIf="config.showSecondary"
               class="aero-dialog-secondary-button"
               [aeroStyle]="config.secondaryStyle"
               [icon]="config.secondaryIcon"
               [label]="config.secondaryLabel"
               [disabled]="secondaryDisabled"
               (onClick)="onSecondary()">
  </aero-button>
  <aero-button [aeroStyle]="config.primaryStyle"
               class="aero-dialog-primary-button"
               [icon]="config.primaryIcon"
               [label]="config.primaryLabel"
               [disabled]="primaryDisabled"
               (onClick)="onPrimary()">
  </aero-button>
</div>
